import React from 'react';
import { useClearRefinements } from 'react-instantsearch-hooks-web';
import { useSearchStateFiltersDispatch } from '../hooks/useSearchStateFilters';
import useSearchHasRefinement from '../hooks/useSearchHasRefinement';
import IconClose from '../../ui/icons/IconClose';

const SearchFilterClearAll = () => {
	const { canRefine, refine } = useClearRefinements();
	const dispatch = useSearchStateFiltersDispatch();
	const { hasRefinement } = useSearchHasRefinement();
	const handleClick = () => {
		refine();
		dispatch( {
			type: 'reset',
		} );
	};

	if ( canRefine || hasRefinement ) {
		return (
			<div className='tw-mb-4 lg:tw-mb-0'>
				<button
					type="button"
					aria-label="Clear all filters"
					className='tw-px-3 tw-text-charcoal tw-py-0 tw-font-medium tw-rounded-full tw-bg-white tw-border tw-border-steel tw-font-charcoal tw-text-sm tw-flex tw-items-center tw-space-x-2 hover:tw-bg-platinum'
					onClick={() => handleClick()}
				>
					<IconClose size="sm" />
					<span>
                     Clear All Filters
					</span>
				</button>
			</div>
		);
	}
	return null;
};

export default SearchFilterClearAll;
